import {useCallback, useEffect} from 'react';
import {isAndroid, isIOS, isIOS13, isMobile} from 'react-device-detect';
import {useSelector} from 'react-redux';
import {useAppDispatch, useAppSelector} from '../../../redux';
import {setGoToAppHidden} from '../../../redux/actions/runtime/menu';
import {contentSelector} from '../../../redux/selectors/resources';
import getStyle from './style';
import {View} from './view';

const useHref = () => {
  const content = useSelector(contentSelector());

  if (isAndroid) {
    return content.footer.stores.googlePlay;
  }

  if (isIOS || isIOS13) {
    return content.footer.stores.appStore;
  }

  return '';
};

export const GoToApp = () => {
  const dispatch = useAppDispatch();
  const isClosed = useAppSelector((state) => state.runtime.menu.isGoToAppHidden);
  const href = useHref();
  const styles = getStyle();

  useEffect(() => {
    if (isMobile && isClosed === undefined) {
      dispatch(setGoToAppHidden(false));
    }
  }, []);

  const onClose = useCallback(() => {
    dispatch(setGoToAppHidden(true));
  }, []);

  if (isClosed || !href) {
    return null;
  }

  return View({
    onClose,
    styles,
    href,
  });
};
